import {
  TRANSACTION_ACTIONS,
  TRANSACTION_DOWNLOAD_ACTIONS
} from '../../constants/actions'

const getTransactions = (payload) => {
  return {
    type: TRANSACTION_ACTIONS.ON_GET_TRANSACTIONS,
    payload
  }
}

const getExchangeActivityChart = () => {
  return {
    type: TRANSACTION_ACTIONS.ON_GET_EXCHANGE_ACTIVITY_CHART
  }
}

const getTransactionsChartByFilter = () => {
  return {
    type: TRANSACTION_ACTIONS.ON_GET_TRANSACTIONS_CHART
  }
}

const getTransactionsForDownload = () => {
  return {
    type: TRANSACTION_DOWNLOAD_ACTIONS.ON_GET_TRANSACTIONS_FOR_DOWNLOAD
  }
}

const resetTransactionsDownloadState = () => {
  return {
    type: TRANSACTION_DOWNLOAD_ACTIONS.ON_RESET_STATE
  }
}

const resetTransactionsChartState = () => {
  return {
    type: TRANSACTION_ACTIONS.ON_RESET_CHART_STATE
  }
}

const resetTransactionsState = () => {
  return {
    type: TRANSACTION_ACTIONS.ON_RESET_STATE
  }
}

export {
  getTransactions,
  getExchangeActivityChart,
  getTransactionsForDownload,
  resetTransactionsDownloadState,
  resetTransactionsChartState,
  resetTransactionsState,
  getTransactionsChartByFilter
}
